<div class="dialog-title-content"
     cdkDrag
     cdkDragRootElement=".cdk-overlay-pane"
     cdkDragHandle>
  <div class="dialog-title">{{'common.dialog.crmGlobalSearchDialog.title' | translate}}</div>
  <div class="dialog-close" (click)="closeDialog(false)">
    <mat-icon>close</mat-icon>
  </div>
</div>

<div class="dialog-content no-overflow scroll-content-padding">
    <div class="df-c">
        <div class="df gap30">
            <form [formGroup]="searchForm" class="dialog-form scroll-content-padding df-c gap15" autocomplete="off">
                <div class="df gap20">
                    <app-phone-number-field formControlName="phone"
                                            id="login-phone"
                                            [autoFocus]="true"
                                            [appearance]="'outline'"
                                            [label]="'common.dialog.crmGlobalSearchDialog.title'">
                    </app-phone-number-field>

                    <div class="df jc-c ai-c">
                        <button class="rounded-icon-button active" (click)="search()">
                            <mat-icon>person_search</mat-icon>
                        </button>
                    </div>
                </div>
            </form>
            <app-user-info-component *ngIf="searchResult" [searchResult]="searchResult"></app-user-info-component>
        </div>

        @if (searchResult?.emailUnsubscribed) {
            <div class="key-value">
                <div class="key">
                    E-mail адреси користувача, що відписані від розcилки листів Дах:
                </div>
            </div>
            <div class="df-c gap5">
                @for (email of searchResult.unsubscribedEmails; let i = $index; track i) {
                    <div>{{email}}</div>
                }
            </div>
        }

    </div>


  <mat-divider class="divider"></mat-divider>

  <app-global-search-component
          [searchResult]="searchResult"
          [showCrmInfo]="true"
  ></app-global-search-component>
</div>
